const BASE_URL = "https://aqar-api.mohamad-rasoul.website";
const PREDICT_URL = "https://real-estate-ai-vi4h.onrender.com";
export { BASE_URL, PREDICT_URL };
